import { VyllageOffice } from "@/components/vyllage/VyllageOffice";

export function OfficePage() {
  return <VyllageOffice />;
}
